
import React from 'react';

const VibeMap = ({ physical = { x: 0, y: 0 }, target = null, matchType }) => {
    // Coordinate conversion: -50 ~ 50 -> 0% ~ 100%
    const toPercent = (val) => {
        const n = parseFloat(val);
        if (isNaN(n)) return 50; // default to center
        return ((n + 50) / 100) * 100;
    };

    const px = toPercent(physical?.x);
    const py = 100 - toPercent(physical?.y);
    const hasTarget = Boolean(
        target
        && Number.isFinite(Number(target.x))
        && Number.isFinite(Number(target.y))
    );
    const tx = hasTarget ? toPercent(target.x) : null;
    const ty = hasTarget ? 100 - toPercent(target.y) : null;

    return (
        <div className="vibe-map-container">
            <div className="vibe-map">
                {/* Axis Labels */}
                <div className="label top">Unique</div>
                <div className="label bottom">Practical</div>
                <div className="label left">Cuteness</div>
                <div className="label right">Masculine</div>

                {/* Grid Lines */}
                <div className="grid-line horizontal" />
                <div className="grid-line vertical" />

                {/* Points */}
                {hasTarget ? (
                    <div
                        className="point target"
                        style={{ left: `${tx}%`, top: `${ty}%` }}
                        title="Target (Ideal)"
                    >
                        <div className="pulse" />
                    </div>
                ) : null}

                <div
                    className="point physical"
                    style={{ left: `${px}%`, top: `${py}%` }}
                    title="Physical (Reality)"
                />

                {/* Connection Line */}
                <svg className="connection-svg">
                    {hasTarget ? (
                        <line
                            x1={`${tx}%`} y1={`${ty}%`}
                            x2={`${px}%`} y2={`${py}%`}
                            stroke="rgba(255,255,255,0.3)"
                            strokeWidth="2"
                            strokeDasharray="4"
                        />
                    ) : null}
                </svg>
            </div>

            <div className="map-legend">
                <div className="legend-item">
                    <span className="dot target" /> <span className="label-text">추구하는 스타일 (Ideal)</span>
                </div>
                <div className="legend-item">
                    <span className="dot physical" /> <span className="label-text">현재 나의 얼굴 (Reality)</span>
                </div>
            </div>

            <style jsx>{`
                .vibe-map-container {
                    margin: 2rem 0;
                    width: 100%;
                }
                .vibe-map {
                    position: relative;
                    width: 100%;
                    aspect-ratio: 1;
                    background: rgba(15, 23, 42, 0.5);
                    border: 2px solid rgba(255, 255, 255, 0.1);
                    border-radius: 20px;
                    overflow: hidden;
                    box-shadow: inset 0 0 40px rgba(0,0,0,0.5);
                }
                .label {
                    position: absolute;
                    font-size: 0.75rem;
                    font-weight: bold;
                    color: rgba(255,255,255,0.4);
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                }
                .label.top { top: 10px; left: 50%; transform: translateX(-50%); }
                .label.bottom { bottom: 10px; left: 50%; transform: translateX(-50%); }
                .label.left { left: 10px; top: 50%; transform: translateY(-50%) rotate(-90deg); transform-origin: center; }
                .label.right { right: 10px; top: 50%; transform: translateY(-50%) rotate(90deg); transform-origin: center; }

                .grid-line {
                    position: absolute;
                    background: rgba(255,255,255,0.05);
                }
                .grid-line.horizontal { top: 50%; left: 0; width: 100%; height: 1px; }
                .grid-line.vertical { left: 50%; top: 0; width: 1px; height: 100%; }

                .point {
                    position: absolute;
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                    transform: translate(-50%, -50%);
                    z-index: 10;
                    box-shadow: 0 0 15px currentColor;
                }
                .point.target {
                    background: #f472b6;
                    color: #f472b6;
                }
                .point.physical {
                    background: #60a5fa;
                    color: #60a5fa;
                }
                
                .pulse {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    background: inherit;
                    border-radius: 50%;
                    animation: pulse-ring 2s cubic-bezier(0.455, 0.03, 0.515, 0.955) infinite;
                }

                @keyframes pulse-ring {
                    0% { transform: scale(0.8); opacity: 0.5; }
                    80%, 100% { transform: scale(2.5); opacity: 0; }
                }

                .connection-svg {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    pointer-events: none;
                }

                .map-legend {
                    display: flex;
                    justify-content: center;
                    gap: 2rem;
                    margin-top: 1.5rem;
                }
                .legend-item {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                }
                .dot {
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                }
                .dot.target { background: #f472b6; }
                .dot.physical { background: #60a5fa; }
                .label-text {
                    font-size: 0.85rem;
                    color: #94a3b8;
                }
            `}</style>
        </div>
    );
};

export default VibeMap;
